import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { ColorPickerModule } from './angular2-color-picker/color-picker.module';
import {
    CkEditorCdListPropertiesPluginModule
} from './ck-editor-cd-list-properties-plugin/ck-editor-cd-list-properties-plugin.module';
import {
    CkEditorFetchWebPageContentPluginModule
} from './ck-editor-fetch-web-page-content-plugin/ck-editor-fetch-web-page-content.module';
import { CkEditorInsertImagePluginModule } from './ck-editor-insert-image-plugin/ck-editor-insert-image-plugin.module';
import {
    CkEditorPersonalizationPluginModule
} from './ck-editor-personalization-plugin/ck-editor-personalization-plugin.module';
import { CommonComponentsModule } from './components/common-components.module';
import { CdDateTimePickerModule } from './components/date-time-picker/cd-date-time-picker.module';
import { ConditionsModule } from './conditions/conditions.module';
import { CrmEntitiesService } from './crm-entities/crm-entities.service';
import { DialogModule } from './dialogs/dialogs.module';
import { CommonDirectivesModule } from './directives/common-directives.module';
import { FileManagerModule } from './file-manager/file-manager.module';
import { HttpModule } from './http/http.module';
import { LookupDialogModule } from './lookup-dialog-component/lookup-dialog.module';
import { LOG_LOGGER_PROVIDERS } from './monitoring/logger/providers';
import { CommonPipesModule } from './pipes/common-pipes.module';
import { ImageEditorService } from './services/image-editor.service';
import {
    AccountService, AppStateService, CommonServicesModule, FeatureflagService, FeatureflagServiceV2,
    GlobalUiPersistenceService, InboxPreviewService
} from './services/index';
import { WebContentDataApi } from './services/web-content-data.api';
import { WebContentDataService } from './services/web-content-data.service';
import { ApiModule } from './typescript-angular-client/api.module';
import { Configuration } from './typescript-angular-client/configuration';

const modulesImportedAndExported = [
  CommonPipesModule,
  CommonComponentsModule,
  CommonDirectivesModule,
  DialogModule,
  CdDateTimePickerModule,
  HttpModule,
  ColorPickerModule,
  CkEditorCdListPropertiesPluginModule,
  CkEditorPersonalizationPluginModule,
  CkEditorFetchWebPageContentPluginModule,
  CkEditorInsertImagePluginModule,
  FileManagerModule,
  ConditionsModule,
  LookupDialogModule,
  CommonServicesModule,
];

export function DumbApiConfiguration(): Configuration {
  return null;
}

@NgModule({
  declarations: [
    /*CommonLibComponent*/
  ],
  imports: [
    ...modulesImportedAndExported,
    ApiModule.forRoot(DumbApiConfiguration),
  ],
  exports: modulesImportedAndExported,
  providers: [
    WebContentDataService,
    WebContentDataApi,
    AppStateService,
    InboxPreviewService,
    CrmEntitiesService,
    GlobalUiPersistenceService,
    FeatureflagService,
    FeatureflagServiceV2,
    AccountService,
    LOG_LOGGER_PROVIDERS,
    ImageEditorService,
  ],
})
export class CommonLibModule {
  constructor(@Optional() @SkipSelf() parentModule: CommonLibModule) {
    if (parentModule) {
      throw new Error(
        'CommonLibModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CommonLibModule,
    };
  }
}
